const NotFound = () => {
    return (
        <>404 - Page Not Found</>
    )
}

export default NotFound;